<div class="spinner-overlay" *ngIf="cargando">
  <div class="spinner"></div>
</div>

<section>
  <div>
    <div class="container-principal">
      <div class=" txtNombre ">
        <div class="cuadroContent">

          <div class="txtNombre">

            <h2 class="titulo-evento3">{{evento?.nombre}}</h2>
            <hr class="linea-naranja4" />

            <h3 class="pulep">
              <ng-container *ngIf="evento?.pulep">
                <span *ngIf="!evento.pulep.startsWith('AT20')">PULEP:&nbsp;</span>
                {{evento?.pulep}}
              </ng-container>
            </h3>

            <br>

            <div class="infoEventCompra">


              <div class="espacioText">
                <div class="alineacionText">
                  <div class="flot typ lato">
                    <img class="logosEvents"
                      src="../../../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 39.png" alt="">
                    <div class="detalle1"><strong class="">Fecha del evento:&nbsp; </strong> {{ darFecha(evento)}}</div>
                  </div>
                  <div class="flot typ lato">
                    <img class="logosEvents"
                      src="../../../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 43.png" alt="">
                    <div class="detalle1"><strong class="">Ciudad:&nbsp; </strong> {{evento?.ciudad?.nombre}}</div>
                  </div>
                  <div class="flot typ lato">
                    <img class="logosEvents"
                      src="../../../../../assets/images/Vectores/Vectores_Mesa de trabajo 1 copia 38.png" alt="">
                    <div class="detalle1"><strong class="">Lugar:&nbsp; </strong> {{ evento?.lugar ? evento?.lugar :
                      "Por confirmar" }}</div>
                  </div>
                </div>
              </div>
              <div class="contenedorImagen">
                <img [src]="darURL(5) && darURL(5) !== '' ? darURL(5) : darURL(1)"
                  [ngClass]="(darURL(5) && darURL(5) !== '') ? 'eventImg1' : 'eventImg'" alt="">
              </div>


            </div>


            <div class="clearFix ml-2">
              <div class="titCpra montserrat">Compra de Tickets</div>
              <hr class="linea-naranja5" />
              <div class="lato txtCpra">Selecciona la cantidad de tickets y localidad que deseas comprar</div>
              <div class="marT8">
                <a class="txtSeguro " href="https://www.metlife.com.co/">Recuerda comprar el seguro MetLife en el
                  siguiente paso</a>
              </div>
            </div>

          </div>

          <!-- Llamado al componente mapa si el evento tiene un mapa asignado -->
          <div style="width: 100%!important;" *ngIf="evento?.mapa_id && !evento?.soldOut">
            <app-mapa [mapaId]="evento.mapa_id" [eventoId]="evento.id" [cliente]="cliente" [localidades]="localidades"
              [mensaje]="mensaje" [modalLogin]="openDialog">
            </app-mapa>
          </div>



          <div *ngIf="evento.mapa_id == null && !evento?.soldOut">

            <div class="tblCpra esconder">

              <table class="table">
                <thead>
                  <tr>
                    <th class="titulosTablas">Localidad</th>
                    <th class="titulosTablas">Precio incluido servicio</th>
                    <th class="titulosTablas">Cantidad</th>
                    <th class="titulosTablas">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let localidad of localidades; let i = index">
                    <td>
                      {{localidad.nombre}}
                      <br>
                    </td>

                    <td>
                      <!-- HARDCODE DOOM ZONA CERO
                      ELIMINAR VALIDACION CUANDO EL EVENTO PASE -->
                      {{(evento?.id === 1986
                      ? (localidad.precio + localidad.servicio_iva + localidad.servicio)
                      : (localidad.precio + localidad.servicio_iva + localidad.servicio) *
                      localidad.cantidadPersonasPorTicket)
                      | currency:'COP'}}
                      <br>
                      <small class="naranja bold-lato">
                        Por {{localidad.cantidadPersonasPorTicket}} Ticket<span
                          *ngIf="localidad.cantidadPersonasPorTicket>1">s</span>
                      </small>
                    </td>

                    <td>
                      <select [(ngModel)]="cantidades[i]" [disabled]="validar(i)" (change)="agregarBoletasACompra(i)">
                        <option [ngValue]="0">0</option>
                        <option [ngValue]="1">1</option>
                        <option [ngValue]="2">2</option>
                        <option [ngValue]="3">3</option>
                        <option [ngValue]="4">4</option>
                        <option [ngValue]="5">5</option>
                        <option [ngValue]="6">6</option>
                      </select>
                    </td>

                    <td>
                       <!-- HARDCODE DOOM ZONA CERO
                      ELIMINAR VALIDACION CUANDO EL EVENTO PASE -->
                      {{(evento?.id === 1986
                      ? (localidad.precio + localidad.servicio + localidad.servicio_iva) * cantidades[i]
                      : (localidad.precio + localidad.servicio + localidad.servicio_iva) * cantidades[i] *localidad.cantidadPersonasPorTicket)
                      | currency:'COP'}}
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div class="boxTotal">
              <div class="cajaTotales">
                <div class="txtBoxTotal">
                  <div class="montserrat colorLetra"> <strong class="total">Total: </strong> {{valorTotal |
                    currency:'COP'}} </div>
                  <div class="montserrat colorLetra"><strong class="total">Cantidad: </strong> {{cantidadTotal}} </div>
                </div>
                <div class="botonFinal">
                  <button class="action_button btnBoxToatl" (click)="AbrirCarrito()">COMPRAR</button>
                </div>
              </div>
            </div>

          </div>

          <section class="container-fluid centrarTexto mt-5" *ngIf="evento?.soldOut">
            <img class="soldoutImg" src="../../../assets/images/img/SOLDOUT.png" class="w-50" alt="">
          </section>

        </div>
      </div>

    </div>

  </div>



</section>